import React from "react";
import "./Skills.css";
import TechLogos from "./TechLogos ";

const skills = [
  // Développement web
  { name: "WordPress", level: 5, category: "CMS" },
  { name: "Oxygen Builder", level: 5, category: "CMS" },
  { name: "Elementor", level: 5, category: "CMS" },
  { name: "Prestashop", level: 4, category: "CMS" },
  { name: "Joomla", level: 4, category: "CMS" },
  { name: "Shopify", level: 3, category: "CMS" },

  // Frameworks & Stacks
  {
    name: "MERN (MongoDB, Express, React, Node)",
    level: 4,
    category: "Framework",
  },
  { name: "ReactJS", level: 4, category: "Framework" },
  { name: "Next.js", level: 3, category: "Framework" },
  { name: "NestJS", level: 3, category: "Framework" },
  { name: "Symfony", level: 4, category: "Framework" },
  { name: "Laravel", level: 4, category: "Framework" },

  // ERP & CRM
  { name: "Odoo v16", level: 5, category: "ERP/CRM" },
  { name: "Zoho", level: 4, category: "ERP/CRM" },

  // Langages
  { name: "PHP", level: 4, category: "Langage" },
  { name: "JavaScript", level: 4, category: "Langage" },
  { name: "Python", level: 3, category: "Langage" },

  // Autres
  { name: "MySQL", level: 4, category: "Base de données" },
  { name: "Gestion serveurs & réseaux", level: 4, category: "Système" },
  { name: "SEO", level: 3, category: "Web" },
  { name: "Docker", level: 3, category: "DevOps" },
  { name: "Git", level: 4, category: "Outils" },
];

function Skills() {
  // Pour affichage en 3 colonnes
  const columns = 3;
  const skillsPerColumn = Math.ceil(skills.length / columns);
  const skillColumns = Array.from({ length: columns }, (_, i) =>
    skills.slice(i * skillsPerColumn, (i + 1) * skillsPerColumn)
  );

  return (
    <section className="skills-section">
      <h2>Compétences</h2>
      <div className="skills-columns">
        {skillColumns.map((col, colIdx) => (
          <div className="skills-col" key={colIdx}>
            {col.map((skill, idx) => (
              <div key={idx} className="skill">
                <span className="skill-name">{skill.name}</span>
                <div className="skill-bar">
                  <div
                    className="skill-level"
                    style={{ width: `${skill.level * 20}%` }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className="skills-note">
        <span role="img" aria-label="rocket">
          🚀
        </span>
        Toujours en veille sur les nouveaux outils et technologies du web, ERP
        et e-commerce.
      </div>
      <TechLogos />
    </section>
  );
}

export default Skills;
